(function ($) {

    // Interim measure: browser language is used as a proxy for UK visitors since
    // true geo-blocking is not currently feasible. Private/direct links are unaffected
    // as this only ever hides/alters content, it never blocks a direct page request.
    function getLanguage() {
        return navigator.userLanguage ||
            (navigator.languages && navigator.languages.length && navigator.languages[0]) ||
            navigator.language ||
            navigator.browserLanguage ||
            navigator.systemLanguage ||
            'en';
    }

    function hasAllowAccessOverride() {
        try {
            var search = window.location.search;
            if (/[?&](allow_access|bypass_uk)=(true|1)/i.test(search)) {
                sessionStorage.setItem('chelsea_allow_access', 'true');
                return true;
            }
            if (sessionStorage.getItem('chelsea_allow_access') === 'true') {
                return true;
            }
        } catch (e) {}
        return false;
    }

    function isUKBrowser() {
        if (hasAllowAccessOverride()) {
            return false;
        }
        return getLanguage().toLowerCase() === 'en-gb';
    }

    // Toggles to re-enable these behaviours in future without removing the code.
    var SHOW_UK_RESTRICTION_NOTICE = false;
    var HIDE_CHELSEA_FROM_LISTINGS = false;

    $(function () {
        // Always show the UK-restriction notice on the Chelsea category page, regardless of visitor location.
        if (SHOW_UK_RESTRICTION_NOTICE && document.body.classList.contains('term-chelsea')) {
            var $eventsLoop = $('#events').first();
            if ($eventsLoop.length && !$('.c-edge-uk-restriction-notice').length) {
                // grid-column/width force this onto its own full-width row, since #events sits inside a CSS grid.
                $eventsLoop.before(
                    '<div class="c-edge-uk-restriction-notice" style="background:#ff0000;color:#fff;padding:20px;grid-column:1/-1;width:100%;box-sizing:border-box;">' +
                    'IMPORTANT - These events are only available to non-UK customers. Any orders placed by UK customers will be cancelled.' +
                    '</div>'
                );
            }
        }

        // Chelsea FC packages are not available to UK customers, so hide the price shown on their
        // event listing cards (category archives, search results, related loops, etc). Scoped to
        // actual product loop cards, not the broader .product_cat-chelsea class, so this can't
        // accidentally catch unrelated page regions, e.g. the related blogs sidebar.
        if (isUKBrowser() && !document.body.classList.contains('single-product')) {
            $('li.product.product_cat-chelsea').addClass('c-edge-uk-price-hidden');
        }

        // Chelsea events now list normally for everyone; UK preventative measures are handled solely
        // on the product page itself (see single-product-page.js).
        if (!HIDE_CHELSEA_FROM_LISTINGS || !isUKBrowser()) {
            return;
        }

        // Single product pages are handled separately by single-product-page.js; skip here so we
        // don't also match .c-edge-product-package-wrapper nested inside the product page itself.
        if (document.body.classList.contains('single-product')) {
            return;
        }

        // Hide Chelsea FC packages from category listings, search results and other loops.
        // Scoped to actual product loop cards (not the broader .product_cat-chelsea class) so this
        // can't accidentally catch unrelated page regions, e.g. the related blogs sidebar.
        $('li.product.product_cat-chelsea').hide();
    });

})(jQuery);
